import React, { useState } from 'react';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const RecipeMode: React.FC = () => {
  // State to control the visibility of the method section
  const [showMethod, setShowMethod] = useState(true); // initially show method

  // Toggle function for method visibility
  const toggleMethodVisibility = () => {
    setShowMethod((prev) => !prev);
  };

  return (
    <Grid
      sx={{
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      {/* Ingredients Section */}
      <Typography variant="body1" fontWeight="bold">
        Ingredients
      </Typography>

      {/* Method Section (conditionally rendered) */}
      {showMethod && (
        <Typography variant="body1" fontWeight="bold" sx={{ mt: 30 }}>
          Method
        </Typography>
      )}

      {/* Icon Button */}
      <IconButton
        onClick={toggleMethodVisibility}
        sx={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: '#f0f0f0',
          },
        }}
      >
        <ExpandLessIcon />
      </IconButton>
    </Grid>
  );
};
